var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 416,
    viewBox: "0 0 538 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-40.6168 434.921L117.958 348.129M117.958 348.129L67.7558 271.687M117.958 348.129L243.029 324.067M67.7558 271.687L73.8901 144.137M67.7558 271.687L-147.59 379.919M67.7558 271.687L243.029 324.067M243.029 324.067L397.436 436.396L523.043 396.094L243.029 324.067Z",
    stroke: "#D8D8D8",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.3196,
    cy: 271.953,
    rx: 15.8386,
    ry: 16.3373,
    transform: "rotate(-38 65.3196 271.953)",
    fill: "#EA4335"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.5091,
    cy: 141.086,
    rx: 15.4219,
    ry: 15.9073,
    transform: "rotate(-38 71.5091 141.086)",
    fill: "#34A853"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.27149,
    cy: 9.08844,
    rx: 9.27149,
    ry: 9.08844,
    transform: "matrix(0.885609 0.464431 -0.443275 0.896385 237.413 309.905)",
    fill: "#EA4335"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.75946,
    cy: 9.56678,
    rx: 9.75946,
    ry: 9.56678,
    transform: "matrix(0.885609 0.464431 -0.443275 0.896385 111.315 335.314)",
    fill: "#F9AB00"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.02751,
    cy: 8.84928,
    rx: 9.02751,
    ry: 8.84928,
    transform: "matrix(0.885609 0.464431 -0.443275 0.896385 517.066 384.303)",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftBg);
export default __webpack_public_path__ + "static/media/bottom-left-bg.4815d31cfcc98fdf0702ccb3f00c5d7b.svg";
export { ForwardRef as ReactComponent };